
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * RejectInfoCode enum
 */
class RejectInfoCode {
  /**
   * Initialize enum with a given value
   * @param {RejectInfoCode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof RejectInfoCode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!RejectInfoCode}
   * @param {!RejectInfoCode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof RejectInfoCode)) {
      throw new TypeError('Instance of RejectInfoCode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!RejectInfoCode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!RejectInfoCode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === RejectInfoCode.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === RejectInfoCode.ACCOUNT_GROUP_NAME.value) {
      return 'ACCOUNT_GROUP_NAME'
    }
    if (this.value === RejectInfoCode.ACCOUNT_LOGIN.value) {
      return 'ACCOUNT_LOGIN'
    }
    if (this.value === RejectInfoCode.ACCOUNT_NAME.value) {
      return 'ACCOUNT_NAME'
    }
    if (this.value === RejectInfoCode.SYMBOL_GROUP_NAME.value) {
      return 'SYMBOL_GROUP_NAME'
    }
    if (this.value === RejectInfoCode.SYMBOL_NAME.value) {
      return 'SYMBOL_NAME'
    }
    if (this.value === RejectInfoCode.ORDER_ID.value) {
      return 'ORDER_ID'
    }
    if (this.value === RejectInfoCode.ORDER_SIDE.value) {
      return 'ORDER_SIDE'
    }
    if (this.value === RejectInfoCode.ORDER_TYPE.value) {
      return 'ORDER_TYPE'
    }
    if (this.value === RejectInfoCode.ORDER_STATUS.value) {
      return 'ORDER_STATUS'
    }
    if (this.value === RejectInfoCode.ORDER_LIMIT_PRICE.value) {
      return 'ORDER_LIMIT_PRICE'
    }
    if (this.value === RejectInfoCode.ORDER_STOP_PRICE.value) {
      return 'ORDER_STOP_PRICE'
    }
    if (this.value === RejectInfoCode.ORDER_OPEN_PRICE.value) {
      return 'ORDER_OPEN_PRICE'
    }
    if (this.value === RejectInfoCode.ORDER_TP_PRICE.value) {
      return 'ORDER_TP_PRICE'
    }
    if (this.value === RejectInfoCode.ORDER_SL_PRICE.value) {
      return 'ORDER_SL_PRICE'
    }
    if (this.value === RejectInfoCode.ORDER_PENDING_COUNT.value) {
      return 'ORDER_PENDING_COUNT'
    }
    if (this.value === RejectInfoCode.ORDER_COUNT.value) {
      return 'ORDER_COUNT'
    }
    if (this.value === RejectInfoCode.CURRENT_BID_PRICE.value) {
      return 'CURRENT_BID_PRICE'
    }
    if (this.value === RejectInfoCode.CURRENT_ASK_PRICE.value) {
      return 'CURRENT_ASK_PRICE'
    }
    if (this.value === RejectInfoCode.CURRENT_OPEN_PRICE.value) {
      return 'CURRENT_OPEN_PRICE'
    }
    if (this.value === RejectInfoCode.CURRENT_CLOSE_PRICE.value) {
      return 'CURRENT_CLOSE_PRICE'
    }
    if (this.value === RejectInfoCode.PASSWORD_INVALID_LENGTH.value) {
      return 'PASSWORD_INVALID_LENGTH'
    }
    if (this.value === RejectInfoCode.PASSWORD_INVALID_SYMBOL.value) {
      return 'PASSWORD_INVALID_SYMBOL'
    }
    if (this.value === RejectInfoCode.PASSWORD_NO_LOWER.value) {
      return 'PASSWORD_NO_LOWER'
    }
    if (this.value === RejectInfoCode.PASSWORD_NO_UPPER.value) {
      return 'PASSWORD_NO_UPPER'
    }
    if (this.value === RejectInfoCode.PASSWORD_NO_DIGITS.value) {
      return 'PASSWORD_NO_DIGITS'
    }
    if (this.value === RejectInfoCode.PASSWORD_NO_SPECIAL_SYMBOLS.value) {
      return 'PASSWORD_NO_SPECIAL_SYMBOLS'
    }
    if (this.value === RejectInfoCode.LANGUAGE_NAME.value) {
      return 'LANGUAGE_NAME'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!RejectInfoCode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!RejectInfoCode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!RejectInfoCode} Created enum
   */
  static fromObject (other) {
    return new RejectInfoCode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.UNKNOWN = new RejectInfoCode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ACCOUNT_GROUP_NAME = new RejectInfoCode(100 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ACCOUNT_LOGIN = new RejectInfoCode(200 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ACCOUNT_NAME = new RejectInfoCode(200 + 1)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.SYMBOL_GROUP_NAME = new RejectInfoCode(300 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.SYMBOL_NAME = new RejectInfoCode(400 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_ID = new RejectInfoCode(500 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_SIDE = new RejectInfoCode(500 + 1)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_TYPE = new RejectInfoCode(500 + 2)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_STATUS = new RejectInfoCode(500 + 3)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_LIMIT_PRICE = new RejectInfoCode(500 + 4)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_STOP_PRICE = new RejectInfoCode(500 + 5)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_OPEN_PRICE = new RejectInfoCode(500 + 6)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_TP_PRICE = new RejectInfoCode(500 + 7)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_SL_PRICE = new RejectInfoCode(500 + 8)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_PENDING_COUNT = new RejectInfoCode(500 + 9)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.ORDER_COUNT = new RejectInfoCode(500 + 10)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.CURRENT_BID_PRICE = new RejectInfoCode(600 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.CURRENT_ASK_PRICE = new RejectInfoCode(600 + 1)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.CURRENT_OPEN_PRICE = new RejectInfoCode(600 + 2)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.CURRENT_CLOSE_PRICE = new RejectInfoCode(600 + 3)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.PASSWORD_INVALID_LENGTH = new RejectInfoCode(700 + 0)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.PASSWORD_INVALID_SYMBOL = new RejectInfoCode(700 + 1)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.PASSWORD_NO_LOWER = new RejectInfoCode(700 + 2)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.PASSWORD_NO_UPPER = new RejectInfoCode(700 + 3)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.PASSWORD_NO_DIGITS = new RejectInfoCode(700 + 4)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.PASSWORD_NO_SPECIAL_SYMBOLS = new RejectInfoCode(700 + 5)
// noinspection PointlessArithmeticExpressionJS
RejectInfoCode.LANGUAGE_NAME = new RejectInfoCode(800 + 0)

export { RejectInfoCode };

/**
 * Fast Binary Encoding RejectInfoCode field model
 */
class FieldModelRejectInfoCode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelRejectInfoCode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelRejectInfoCode}
   * @param {RejectInfoCode=} defaults Default value, defaults is new RejectInfoCode()
   * @returns {!RejectInfoCode} Result value
   */
  get (defaults = new RejectInfoCode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new RejectInfoCode(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelRejectInfoCode}
   * @param {!RejectInfoCode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelRejectInfoCode };
